module.exports = __webpack_public_path__ + "media/images/emblems/Pic_Neuenkirch-0f2f8302bf4e558559c91a8b207e750f.png";